module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;
  return _h('div', {
    attrs: {
      "id": "school-grounds"
    }
  }, [_h('ul', {
    staticClass: "scene"
  }, [_h('li', {
    staticClass: "layer scene__layer scene__layer--ground",
    attrs: {
      "data-depth": "-0.2"
    }
  }, [_h('div', {
    staticClass: "scene__illus scene__illus--ground"
  })]), " ", " ", _h('li', {
    staticClass: "layer scene__layer scene__layer--foreground",
    attrs: {
      "data-depth": "0.0"
    }
  }, [_h('div', {
    staticClass: "sprite sprite--pupil",
    attrs: {
      "data-frames": "49",
      "data-framerate": "15",
      "data-delay": "1500",
      "data-interval": "5000"
    }
  }), " ", _h('div', {
    staticClass: "sprite sprite--butterflies-left",
    attrs: {
      "data-frames": "49",
      "data-framerate": "15",
      "data-delay": "0",
      "data-interval": "0"
    }
  }), " ", _h('div', {
    staticClass: "sprite sprite--butterflies-right",
    attrs: {
      "data-frames": "49",
      "data-framerate": "15",
      "data-delay": "0",
      "data-interval": "0"
    }
  }), " ", _h('img', {
    staticClass: "scene__illus scene__illus--foreground",
    attrs: {
      "src": require("../../assets/svg/school-grounds/foreground.svg"),
      "alt": ""
    }
  })]), " ", " ", _h('li', {
    staticClass: "layer scene__layer scene__layer--midground",
    attrs: {
      "data-depth": "0.2"
    }
  }, [_h('div', {
    staticClass: "sprite sprite--birdhouse",
    attrs: {
      "data-frames": "49",
      "data-framerate": "12",
      "data-delay": "5000",
      "data-interval": "5000"
    }
  }), " ", _h('img', {
    staticClass: "scene__illus scene__illus--midground",
    attrs: {
      "src": require("../../assets/svg/school-grounds/midground.svg"),
      "alt": ""
    }
  })]), " ", " ", _h('li', {
    staticClass: "layer scene__layer scene__layer--background",
    attrs: {
      "data-depth": "1"
    }
  }, [_h('img', {
    staticClass: "anim anim--turbine",
    attrs: {
      "src": require("../../assets/svg/intro/turbine.svg"),
      "alt": ""
    }
  }), " ", _h('img', {
    staticClass: "scene__illus scene__illus--background",
    attrs: {
      "src": require("../../assets/svg/school-grounds/background.svg"),
      "alt": ""
    }
  })]), " ", " ", _h('li', {
    staticClass: "scene__sky"
  }, [_h('img', {
    staticClass: "scene__cloud scene__cloud--first",
    attrs: {
      "src": require("../../assets/svg/scene__clouds-1.svg"),
      "alt": ""
    }
  }), " ", _h('img', {
    staticClass: "scene__cloud scene__cloud--second",
    attrs: {
      "src": require("../../assets/svg/scene__clouds-2.svg"),
      "alt": ""
    }
  }), " ", _h('img', {
    staticClass: "scene__cloud scene__cloud--third",
    attrs: {
      "src": require("../../assets/svg/scene__clouds-1.svg"),
      "alt": ""
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6ff62c23!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/scenes/SceneSchoolGrounds.vue
// module id = 222
// module chunks = 0